<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const showDropdown = ref(false)

function isActive(tabName: string) {
  if (tabName === 'discover')
    return route.name === 'home'
  if (tabName === 'rankings')
    return route.name === 'tags'
  return false
}

function handleDiscover() {
  if (route.name === 'home')
    router.replace({ name: 'home' })
  else
    router.push({ name: 'home' })
}

function handleRankings() {
  router.push('/tags')
}

function handleCreate() {
  window.open('https://author.inkport.top/', '_blank')
}

function toggleDropdown() {
  showDropdown.value = !showDropdown.value
}

function handleDropdownItem(url: string) {
  showDropdown.value = false
  window.open(url, '_blank')
}

function closeDropdown() {
  showDropdown.value = false
}

onMounted(() => {
  document.addEventListener('click', closeDropdown)
})

onUnmounted(() => {
  document.removeEventListener('click', closeDropdown)
})
</script>

<template>
  <nav class="flex items-center" style="gap: 30px">
    <!-- Tab1: Discover -->
    <button
      class="relative"
      style="font-weight: 500; font-size: 16px; border: none; background: none; padding: 0 0 4px; cursor: pointer; white-space: nowrap"
      :style="{ color: isActive('discover') ? '#9875FB' : '#323435' }"
      @click="handleDiscover"
    >
      Discover
      <span
        v-if="isActive('discover')"
        style="position: absolute; bottom: 0; left: 0; right: 0; height: 2px; background: #9875FB; border-radius: 9999px"
      />
    </button>

    <!-- Tab2: Rankings -->
    <button
      class="relative"
      style="font-weight: 500; font-size: 16px; border: none; background: none; padding: 0 0 4px; cursor: pointer; white-space: nowrap"
      :style="{ color: isActive('rankings') ? '#9875FB' : '#323435' }"
      @click="handleRankings"
    >
      Rankings
      <span
        v-if="isActive('rankings')"
        style="position: absolute; bottom: 0; left: 0; right: 0; height: 2px; background: #9875FB; border-radius: 9999px"
      />
    </button>

    <!-- Tab3: Create -->
    <button
      class="relative"
      style="font-weight: 500; font-size: 16px; border: none; background: none; padding: 0 0 4px; cursor: pointer; white-space: nowrap; color: #323435"
      @click="handleCreate"
    >
      Create
    </button>

    <!-- Tab4: Writer Benefit (dropdown) -->
    <div class="relative" style="padding-bottom: 4px" @click.stop>
      <button
        style="font-weight: 500; font-size: 16px; border: none; background: none; padding: 0; cursor: pointer; white-space: nowrap; color: #323435; display: flex; align-items: center; gap: 4px"
        @click="toggleDropdown"
      >
        Writer Benefit
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 48 48"
          fill="none"
          style="transition: transform 0.2s"
          :style="{ transform: showDropdown ? 'rotate(180deg)' : 'rotate(0deg)' }"
        >
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M12 19l12 12 12-12" />
        </svg>
      </button>

      <!-- Dropdown -->
      <div
        v-if="showDropdown"
        style="position: absolute; top: calc(100% + 8px); left: 50%; transform: translateX(-50%); background: #fff; border-radius: 8px; box-shadow: 0 4px 16px rgba(0,0,0,0.12); min-width: 160px; z-index: 100; overflow: hidden"
      >
        <button
          class="dropdown-item"
          @click="handleDropdownItem('https://author.inkport.top/writer-benefits.html')"
        >
          Author Benefits
        </button>
        <button
          class="dropdown-item"
          @click="handleDropdownItem('https://author.inkport.top/welfare-ae.html')"
        >
          AE Benefits
        </button>
      </div>
    </div>
  </nav>
</template>

<style scoped>
.dropdown-item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 16px;
  font-size: 14px;
  color: #323435;
  border: none;
  background: none;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;
}

.dropdown-item:hover {
  color: #9875FB;
}
</style>
